import { Button } from "@deliverr/ui";
import { ModalTemplate, SoundFx } from "@deliverr/ui-facility";
import React from "react";
import { FormattedMessage } from "react-intl";
import { useSortationModal } from "sortation/components/SortationModal";
import { sortationDangerIconProps } from "sortation/components/SortationModal/sortationModalIconProps";
import { OutboundModal } from "./OutboundModal";

export const InvalidGaylordCodeModal: React.FC = () => {
  const { hideModal } = useSortationModal();
  return (
    <ModalTemplate
      title={<FormattedMessage id="sortation.scanGaylord.invalidGaylordTitle" defaultMessage="Invalid gaylord code" />}
      text={
        <FormattedMessage
          id="sortation.scanGaylord.invalidGaylordBody"
          defaultMessage={"This barcode is unrecognized. Scan again or try another gaylord."}
        />
      }
      iconProps={sortationDangerIconProps}
      soundFx={SoundFx.ERROR_FAST}
      data-testid="invalid_gaylord_code_modal"
    >
      <Button block onClick={() => hideModal(OutboundModal.INVALID_GAYLORD_CODE)}>
        <FormattedMessage id="sortation.scanGaylord.understandConfirm" defaultMessage="I understand" />
      </Button>
    </ModalTemplate>
  );
};
